// src/pages/Perfil.jsx
import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Card, Spin, Descriptions, Image, Button, Grid, Tag } from "antd";
import { ArrowLeftOutlined } from "@ant-design/icons";
import axios from "axios";

const Perfil = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const screens = Grid.useBreakpoint();
  useEffect(() => {
    const fetchUser = async () => {
      try {
        const res = await axios.get(`https://app-swingervip-production.up.railway.app/api/user/${id}`);
        setUser(res.data);
      } catch (error) {
        console.error("Error al obtener el perfil:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchUser();
  }, [id]);

  if (loading) {
    return (
      <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh" }}>
        <Spin size="large" />
      </div>
    );
  }

  if (!user) {
    return <p style={{ textAlign: "center", color: "red" }}>Perfil no encontrado</p>;
  }

  const { Perfil } = user;

  return (
    <div className="admin-profile-page">
      <Button
        type="link"
        onClick={() => navigate(-1)}
        icon={<ArrowLeftOutlined />}
        style={{ marginBottom: "20px" }}
      >
        Volver a Usuarios
      </Button>

      <Card
        title={`${user.nombre} ${user.apellido}`}
        bordered={false}
        className="admin-profile-card"
      >
      <div style={{ marginBottom: "20px" }}>
  {Perfil && Perfil.fotos && Perfil.fotos.length > 0 ? (
    <div className="admin-profile-gallery">
      {Perfil.fotos.map((foto, index) => (
        <div key={index} className="admin-profile-gallery-item">
          <Image
            src={foto.url}
            alt={`Foto ${index + 1}`}
            style={{
              borderRadius: "12px",
              objectFit: "cover",
            }}
          />
        </div>
      ))}
    </div>
  ) : (
    <p>No hay fotos disponibles</p>
  )}
</div>

        {/* Información del usuario */}
        <Descriptions
          title="Información del Usuario"
          bordered
          column={screens.md ? 1 : 1}
          size="middle"
          style={{ marginBottom: "20px" }}
        >
          <Descriptions.Item label="Nombre">{user.nombre}</Descriptions.Item>
          <Descriptions.Item label="Apellido">{user.apellido}</Descriptions.Item>
          <Descriptions.Item label="Email">{user.correo_electronico}</Descriptions.Item>
          <Descriptions.Item label="Teléfono">{user.telefono}</Descriptions.Item>
          <Descriptions.Item label="País">{user.pais}</Descriptions.Item>
          <Descriptions.Item label="Estado">
            <Tag color={user.estado === "activo" ? "green" : "red"}>
              {user.estado.toUpperCase()}
            </Tag>
          </Descriptions.Item>

          {Perfil && (
            <>
              <Descriptions.Item label="Nombre Visible">{Perfil.nombre_visible || "-"}</Descriptions.Item>
              <Descriptions.Item label="Género">{Perfil.genero || "-"}</Descriptions.Item>
              <Descriptions.Item label="Busco">{Perfil.busco || "-"}</Descriptions.Item>
              <Descriptions.Item label="Fecha de Nacimiento">
                {Perfil.fecha_nacimiento ? new Date(Perfil.fecha_nacimiento).toLocaleDateString() : "-"}
              </Descriptions.Item>
              <Descriptions.Item label="Dirección">{Perfil.direccion || "-"}</Descriptions.Item>
              <Descriptions.Item label="Descripción">{Perfil.descripcion || "-"}</Descriptions.Item>
              <Descriptions.Item label="Visibilidad de Foto">{Perfil.visibilidad_foto ? "Sí" : "No"}</Descriptions.Item>
              <Descriptions.Item label="Perfil Público">{Perfil.perfil_publico ? "Sí" : "No"}</Descriptions.Item>
              <Descriptions.Item label="Privacidad Activa">{Perfil.privacidad_activa ? "Sí" : "No"}</Descriptions.Item>
              <Descriptions.Item label="Verificado">{Perfil.verificado ? "Sí" : "No"}</Descriptions.Item>
            </>
          )}
        </Descriptions>
      </Card>
    </div>
  );
};

export default Perfil;
